import axios from "axios";

class CourseService1 {
  async getCourseByID(id: Number) {
    return await axios.get(`course/${id}`);
  }

  async cretateCourse(course: any) {
    return await axios.post("course", course);
  }

  async updateCourse(id: number, course: any) {
    return await axios.put(`course/${id}`, course);
  }

  async deleteCourse(id: number) {
    return await axios.delete(`course/${id}`);
  }
}
const CourseService = new CourseService1();
export default CourseService;
